/**
 * Invitation Type Definitions
 * Shared types for the C2 invitation workflow
 */

/** Invitation status */
export type InvitationStatus = 'pending' | 'accepted' | 'declined' | 'expired';

/** Invitation record as rendered in the blotter */
export interface Invitation {
  id: string;
  /** Reference identifier: ABN, ACN, or other internal reference (not necessarily an email) */
  email: string;
  organisationName: string;
  role: string;
  sentDate: string;
  status: InvitationStatus;
  expiryDate: string;
  /** Display name returned by the server for the C1 user who created the invitation. */
  createdByName?: string;
  /** Durable CDEN/legacy identifier, retained for diagnostics but never shown raw. */
  createdBy?: string;
  createdDate?: string;
  c2Username?: string;
  tempPassword?: string;
}

/** Risk-badge config for the invitations blotter */
export interface RiskBadgeConfig {
  label: string;
  color: string;
  bg: string;
}

export const RISK_BADGE_CONFIG: Record<'HIGH' | 'MEDIUM' | 'LOW', RiskBadgeConfig> = {
  HIGH: { label: 'High Risk', color: '#721c24', bg: '#f8d7da' },
  MEDIUM: { label: 'Medium Risk', color: '#856404', bg: '#fff3cd' },
  LOW: { label: 'Low Risk', color: '#155724', bg: '#d4edda' },
};
